import { post, get } from '../../lib/api';
import type { LoginResponse, VerifyResponse, RefreshResponse, LogoutResponse } from './types';

export async function login(email: string): Promise<LoginResponse> {
  return post<LoginResponse>('/auth/login', { email });
}

export async function verify(token: string, rememberMe: boolean): Promise<VerifyResponse> {
  return get<VerifyResponse>('/auth/verify', { token, rememberMe: rememberMe.toString() });
}

export async function refresh(): Promise<RefreshResponse> {
  return post<RefreshResponse>('/auth/refresh', {});
}

export async function logout(): Promise<LogoutResponse> {
  return post<LogoutResponse>('/auth/logout', {});
}

export async function check(): Promise<VerifyResponse> {
  return get<VerifyResponse>('/auth/check');
} 